import React from 'react';
import Helmet from 'react-helmet';
import Container from '../../components/Container';
import Footer from '../../components/Footer';
import Layout from '../../components/Layout';
import Map from '../../components/Map';
import Tabs from '../../components/Tabs';

import styles from './index.module.scss';

const tabs = ['幼兒園／幼稚園', '小學低年級', '小學高年級'];

const coords = [
  { lat: 22.331272, lng: 114.177496 },
  { lat: 22.32869, lng: 114.178193 },
  { lat: 22.327486, lng: 114.178077 },
];

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    tab: 0,
  };

  render() {
    const {
      pageContext: { langKey, path },
    } = this.props;
    const { tab } = this.state;
    const locale = langKey;

    return (
      <Layout locale={locale} path={path} showHeader fixedHeader>
        <Helmet>
          <title>聯繫我們 - 京斯敦國際學校(香港)</title>
        </Helmet>

        <div className={styles.map}>
          <Map defaultZoom={16} coords={coords[tab]} />
        </div>

        <Container className={styles.container}>
          <h1>聯繫我們</h1>
          <Tabs tabs={tabs} onChangeTab={index => this.setState({ tab: index })} />
          {tab === 0 && (
            <React.Fragment>
              <h3 className={styles.name}>京斯敦幼兒園 (KCC)／京斯敦國際幼稚園 (KIK)</h3>
              <p>香港九龍九龍塘金巴倫道12-14號</p>
              <p>
                電話 : (852) 2337 9049<br />
                傳真 : (852) 2337 7382<br />
                電郵: enquiry@kingston.edu.hk
              </p>
            </React.Fragment>
          )}
          {tab === 1 && (
            <React.Fragment>
              <h3 className={styles.name}>京斯敦國際學校 (KIS) - 小學低年級</h3>
              <p>香港九龍九龍塘窩打老道113號</p>
              <p>
                電話 : (852) 2337 9031<br />
                傳真 : (852) 2337 9970<br />
                電郵: enquiry@kingston.edu.hk
              </p>
            </React.Fragment>
          )}
          {tab === 2 && (
            <React.Fragment>
              <h3 className={styles.name}>京斯敦國際學校 (KIS) - 小學高年級</h3>
              <p>香港九龍九龍塘窩打老道105號</p>
              <p>
                電話 : (852) 2337 9012<br />
                傳真 : (852) 2337 9986<br />
                電郵: enquiry@kingston.edu.hk
              </p>
            </React.Fragment>
          )}
        </Container>
        <Footer locale={locale} showMap={false} />
      </Layout>
    );
  }
}
